import React, { Component } from 'react';

class ContainerRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    subtitle: 'Topic 5',
                    title: 'Real-World Applications',
                    text: 'Take a look at how adaptive control with neural networks is transforming industries, from robotics to finance, with practical applications and case studies.'
                },
                {
                    id: 2,
                    subtitle: 'Topic 6',
                    title: 'Future Trends in Adaptive Control',
                    text: 'This chapter discusses the future trends in adaptive control, exploring technological advancements and the potential for neural networks to revolutionize the field in the coming years.'
                },
                /*{
                    id: 3,
                    subtitle: 'Chapter 9',
                    title: 'The rise of trend Design',
                    text: 'Well-written book is concerned with creating typography and is essential for professionals who regularly '
                }*/
            ]
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collRight.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerRight;
